import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=6c66e925&scoped=true&"
import script from "./FileSelector.vue?vue&type=script&lang=ts&"
export * from "./FileSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FileSelector.vue?vue&type=style&index=0&id=6c66e925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66e925",
  null
  
)

export default component.exports